import { ThemeModeContext } from 'components/providers/ThemeModeProvider';
import { useContext } from 'react';

export type ThemeModeContextType = {
    setThemeMode: (val: 'light' | 'dark') => void;
    themeMode: 'light' | 'dark';
};

export const useThemeModeContext = (): ThemeModeContextType => useContext(ThemeModeContext);
